import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Calendar, TrendingUp, Heart, DollarSign, Brain, ShieldCheck } from 'lucide-react';
const resources = [{
  icon: Calendar,
  title: '1. Guía Práctica de 30 Días',
  desc: 'Tu hoja de ruta diaria. Solo 15 minutos al día para transformar tus finanzas sin agobios.',
  image: 'https://cdn.magicpatterns.com/uploads/rEbP9cdsB5wKXX71QsCx5Z/portada_finanzas_faciles.png'
}, {
  icon: BookOpen,
  title: '2. Diario de Dinero en Acción',
  desc: 'Plantillas imprimibles para rastrear tus gastos y descubrir tus fugas de dinero.',
  image: 'https://cdn.magicpatterns.com/uploads/skbL3ibVy7bjUqX578naJR/portada_bono_4.png'
}, {
  icon: ShieldCheck,
  title: '3. Plan para Salir de Deudas',
  desc: 'Estrategias probadas (bola de nieve y avalancha) explicadas para principiantes.',
  image: 'https://cdn.magicpatterns.com/uploads/aqaWhvwqXbR7suvdSC7kHY/portada_bono2.png'
}, {
  icon: TrendingUp,
  title: '4. Ahorro con Propósito',
  desc: 'Cómo construir tu fondo de emergencia y ahorrar para tus sueños, aunque ganes poco.',
  image: 'https://cdn.magicpatterns.com/uploads/mXmUYZXmhYUCQtpTiNT7mX/portada_bono3.png'
}, {
  icon: Heart,
  title: '5. Dinero en Pareja y Familia',
  desc: 'Guiones y consejos para hablar de dinero sin pelear y construir metas juntos.',
  image: 'https://cdn.magicpatterns.com/uploads/82pjW85xD7qLnv8WLUSVLA/portada_bono1.png'
}, {
  icon: DollarSign,
  title: '6. Obtén Ingresos Extra',
  desc: '20 ideas prácticas para generar dinero adicional desde casa esta misma semana.',
  image: 'https://cdn.magicpatterns.com/uploads/iowyRuUA8sVcfFG7ZcY8wE/portada_bono_5.png'
}, {
  icon: Brain,
  title: '7. Mentalidad de Abundancia',
  desc: 'Afirmaciones y ejercicios para romper bloqueos mentales sobre el dinero.',
  image: 'https://cdn.magicpatterns.com/uploads/dsMDdhavFW6Br34VYUL9Sg/portada_bono_6.png'
}];
const promoImages = [{
  image: 'https://cdn.magicpatterns.com/uploads/8Fz4WZDWBaU1oBzFkp8Hpw/creativo_5.png',
  title: 'Descarga inmediata en tu celular',
  desc: 'Acceso instantáneo desde cualquier dispositivo'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/h4Mf7GxSZkLeiWFqDHRbSU/creativo_1.png',
  title: '¿Lista para dejar de vivir al día?',
  desc: 'Empieza hoy tu plan de 30 días para tus finanzas'
}];
export function HowItWorks() {
  return <section className="py-20 bg-white" data-id="element-434">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-435">
        <div className="text-center mb-16" data-id="element-436">
          <span className="text-[#d4a574] font-bold tracking-wider uppercase text-sm" data-id="element-437">
            ¿Qué incluye el pack?
          </span>
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#1e3a5f] mt-2 mb-4" data-id="element-438">
            Un sistema completo de 7 pasos
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-439">
            No es solo información, es transformación. Cada recurso está
            diseñado para atacar un área específica de tu vida financiera.
          </p>
        </div>

        {/* Mobile: Compact image grid with promotional images */}
        <div className="grid grid-cols-2 gap-0 md:hidden" data-id="element-440">
          {/* Promo Image 1 - Full width */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="col-span-2 relative overflow-hidden" data-id="element-441">
            <div className="relative w-full h-80" data-id="element-442">
              <img src={promoImages[0].image} alt={promoImages[0].title} className="w-full h-full object-cover" data-id="element-443" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#1e3a5f]/90 via-[#1e3a5f]/50 to-transparent" data-id="element-444"></div>
              <div className="absolute bottom-0 left-0 right-0 p-6 text-white" data-id="element-445">
                <h3 className="text-xl font-serif font-bold mb-2 drop-shadow-lg" data-id="element-446">
                  {promoImages[0].title}
                </h3>
                <p className="text-sm text-gray-200 drop-shadow-md" data-id="element-447">
                  {promoImages[0].desc}
                </p>
              </div>
            </div>
          </motion.div>

          {/* Product 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.05
        }} className="relative overflow-hidden" data-id="element-448">
            <div className="relative w-full h-64" data-id="element-449">
              <img src={resources[0].image} alt={resources[0].title} className="w-full h-full object-cover" data-id="element-450" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#1e3a5f] via-[#1e3a5f]/60 to-transparent" data-id="element-451"></div>
              <div className="absolute bottom-0 left-0 right-0 p-4 text-white" data-id="element-452">
                <h3 className="text-sm font-serif font-bold mb-1 drop-shadow-lg" data-id="element-453">
                  {resources[0].title}
                </h3>
                <p className="text-xs text-gray-200 line-clamp-2 drop-shadow-md" data-id="element-454">
                  {resources[0].desc}
                </p>
              </div>
            </div>
          </motion.div>

          {/* Product 2 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="relative overflow-hidden" data-id="element-455">
            <div className="relative w-full h-64" data-id="element-456">
              <img src={resources[1].image} alt={resources[1].title} className="w-full h-full object-cover" data-id="element-457" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#1e3a5f] via-[#1e3a5f]/60 to-transparent" data-id="element-458"></div>
              <div className="absolute bottom-0 left-0 right-0 p-4 text-white" data-id="element-459">
                <h3 className="text-sm font-serif font-bold mb-1 drop-shadow-lg" data-id="element-460">
                  {resources[1].title}
                </h3>
                <p className="text-xs text-gray-200 line-clamp-2 drop-shadow-md" data-id="element-461">
                  {resources[1].desc}
                </p>
              </div>
            </div>
          </motion.div>

          {/* Product 3 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.15
        }} className="relative overflow-hidden" data-id="element-462">
            <div className="relative w-full h-64" data-id="element-463">
              <img src={resources[2].image} alt={resources[2].title} className="w-full h-full object-cover" data-id="element-464" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#1e3a5f] via-[#1e3a5f]/60 to-transparent" data-id="element-465"></div>
              <div className="absolute bottom-0 left-0 right-0 p-4 text-white" data-id="element-466">
                <h3 className="text-sm font-serif font-bold mb-1 drop-shadow-lg" data-id="element-467">
                  {resources[2].title}
                </h3>
                <p className="text-xs text-gray-200 line-clamp-2 drop-shadow-md" data-id="element-468">
                  {resources[2].desc}
                </p>
              </div>
            </div>
          </motion.div>

          {/* Product 4 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="relative overflow-hidden" data-id="element-469">
            <div className="relative w-full h-64" data-id="element-470">
              <img src={resources[3].image} alt={resources[3].title} className="w-full h-full object-cover" data-id="element-471" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#1e3a5f] via-[#1e3a5f]/60 to-transparent" data-id="element-472"></div>
              <div className="absolute bottom-0 left-0 right-0 p-4 text-white" data-id="element-473">
                <h3 className="text-sm font-serif font-bold mb-1 drop-shadow-lg" data-id="element-474">
                  {resources[3].title}
                </h3>
                <p className="text-xs text-gray-200 line-clamp-2 drop-shadow-md" data-id="element-475">
                  {resources[3].desc}
                </p>
              </div>
            </div>
          </motion.div>

          {/* Promo Image 2 - Full width */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.25
        }} className="col-span-2 relative overflow-hidden" data-id="element-476">
            <div className="relative w-full h-80" data-id="element-477">
              <img src={promoImages[1].image} alt={promoImages[1].title} className="w-full h-full object-cover" data-id="element-478" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#1e3a5f]/90 via-[#1e3a5f]/50 to-transparent" data-id="element-479"></div>
              <div className="absolute bottom-0 left-0 right-0 p-6 text-white" data-id="element-480">
                <h3 className="text-xl font-serif font-bold mb-2 drop-shadow-lg" data-id="element-481">
                  {promoImages[1].title}
                </h3>
                <p className="text-sm text-gray-200 drop-shadow-md" data-id="element-482">
                  {promoImages[1].desc}
                </p>
              </div>
            </div>
          </motion.div>

          {/* Product 5 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="relative overflow-hidden" data-id="element-483">
            <div className="relative w-full h-64" data-id="element-484">
              <img src={resources[4].image} alt={resources[4].title} className="w-full h-full object-cover" data-id="element-485" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#1e3a5f] via-[#1e3a5f]/60 to-transparent" data-id="element-486"></div>
              <div className="absolute bottom-0 left-0 right-0 p-4 text-white" data-id="element-487">
                <h3 className="text-sm font-serif font-bold mb-1 drop-shadow-lg" data-id="element-488">
                  {resources[4].title}
                </h3>
                <p className="text-xs text-gray-200 line-clamp-2 drop-shadow-md" data-id="element-489">
                  {resources[4].desc}
                </p>
              </div>
            </div>
          </motion.div>

          {/* Product 6 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.35
        }} className="relative overflow-hidden" data-id="element-490">
            <div className="relative w-full h-64" data-id="element-491">
              <img src={resources[5].image} alt={resources[5].title} className="w-full h-full object-cover" data-id="element-492" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#1e3a5f] via-[#1e3a5f]/60 to-transparent" data-id="element-493"></div>
              <div className="absolute bottom-0 left-0 right-0 p-4 text-white" data-id="element-494">
                <h3 className="text-sm font-serif font-bold mb-1 drop-shadow-lg" data-id="element-495">
                  {resources[5].title}
                </h3>
                <p className="text-xs text-gray-200 line-clamp-2 drop-shadow-md" data-id="element-496">
                  {resources[5].desc}
                </p>
              </div>
            </div>
          </motion.div>

          {/* Product 7 - Full width */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.4
        }} className="col-span-2 relative overflow-hidden" data-id="element-497">
            <div className="relative w-full h-72" data-id="element-498">
              <img src={resources[6].image} alt={resources[6].title} className="w-full h-full object-cover" data-id="element-499" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#1e3a5f] via-[#1e3a5f]/60 to-transparent" data-id="element-500"></div>
              <div className="absolute bottom-0 left-0 right-0 p-6 text-white" data-id="element-501">
                <h3 className="text-lg font-serif font-bold mb-2 drop-shadow-lg" data-id="element-502">
                  {resources[6].title}
                </h3>
                <p className="text-sm text-gray-200 drop-shadow-md" data-id="element-503">
                  {resources[6].desc}
                </p>
              </div>
            </div>
          </motion.div>
        </div>

        <div className="hidden md:grid md:grid-cols-5 md:auto-rows-[280px] md:gap-0" data-id="element-504">
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="md:col-span-2 md:row-span-2 relative group overflow-hidden" data-id="element-505">
            <div className="relative w-full h-full" data-id="element-506">
              <img src={promoImages[0].image} alt={promoImages[0].title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-507" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#1e3a5f]/80 via-[#1e3a5f]/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-508"></div>
              <div className="absolute inset-0 flex flex-col justify-end p-8 opacity-0 group-hover:opacity-100 transition-all duration-500 transform translate-y-4 group-hover:translate-y-0" data-id="element-509">
                <h3 className="text-2xl font-serif font-bold mb-2 text-white drop-shadow-lg" data-id="element-510">
                  {promoImages[0].title}
                </h3>
                <p className="text-base text-gray-100 drop-shadow-md" data-id="element-511">
                  {promoImages[0].desc}
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="md:col-span-1 md:row-span-2 relative group overflow-hidden" data-id="element-512">
            <div className="relative w-full h-full" data-id="element-513">
              <img src={resources[0].image} alt={resources[0].title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-514" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#1e3a5f] via-[#1e3a5f]/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-515"></div>
              <div className="absolute inset-0 flex flex-col justify-end p-6 opacity-0 group-hover:opacity-100 transition-all duration-500 transform translate-y-4 group-hover:translate-y-0" data-id="element-516">
                <h3 className="text-lg font-serif font-bold mb-2 text-white drop-shadow-lg" data-id="element-517">
                  {resources[0].title}
                </h3>
                <p className="text-sm text-gray-100 drop-shadow-md" data-id="element-518">
                  {resources[0].desc}
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.15
        }} className="md:col-span-2 md:row-span-1 relative group overflow-hidden" data-id="element-519">
            <div className="relative w-full h-full" data-id="element-520">
              <img src={resources[1].image} alt={resources[1].title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-521" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#1e3a5f] via-[#1e3a5f]/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-522"></div>
              <div className="absolute inset-0 flex flex-col justify-end p-6 opacity-0 group-hover:opacity-100 transition-all duration-500 transform translate-y-4 group-hover:translate-y-0" data-id="element-523">
                <h3 className="text-lg font-serif font-bold mb-2 text-white drop-shadow-lg" data-id="element-524">
                  {resources[1].title}
                </h3>
                <p className="text-sm text-gray-100 drop-shadow-md" data-id="element-525">
                  {resources[1].desc}
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="md:col-span-1 md:row-span-1 relative group overflow-hidden" data-id="element-526">
            <div className="relative w-full h-full" data-id="element-527">
              <img src={resources[2].image} alt={resources[2].title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-528" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#1e3a5f] via-[#1e3a5f]/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-529"></div>
              <div className="absolute inset-0 flex flex-col justify-end p-6 opacity-0 group-hover:opacity-100 transition-all duration-500 transform translate-y-4 group-hover:translate-y-0" data-id="element-530">
                <h3 className="text-lg font-serif font-bold mb-2 text-white drop-shadow-lg" data-id="element-531">
                  {resources[2].title}
                </h3>
                <p className="text-sm text-gray-100 drop-shadow-md" data-id="element-532">
                  {resources[2].desc}
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.25
        }} className="md:col-span-1 md:row-span-1 relative group overflow-hidden" data-id="element-533">
            <div className="relative w-full h-full" data-id="element-534">
              <img src={resources[3].image} alt={resources[3].title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-535" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#1e3a5f] via-[#1e3a5f]/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-536"></div>
              <div className="absolute inset-0 flex flex-col justify-end p-6 opacity-0 group-hover:opacity-100 transition-all duration-500 transform translate-y-4 group-hover:translate-y-0" data-id="element-537">
                <h3 className="text-lg font-serif font-bold mb-2 text-white drop-shadow-lg" data-id="element-538">
                  {resources[3].title}
                </h3>
                <p className="text-sm text-gray-100 drop-shadow-md" data-id="element-539">
                  {resources[3].desc}
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="md:col-span-1 md:row-span-1 relative group overflow-hidden" data-id="element-540">
            <div className="relative w-full h-full" data-id="element-541">
              <img src={resources[4].image} alt={resources[4].title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-542" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#1e3a5f] via-[#1e3a5f]/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-543"></div>
              <div className="absolute inset-0 flex flex-col justify-end p-6 opacity-0 group-hover:opacity-100 transition-all duration-500 transform translate-y-4 group-hover:translate-y-0" data-id="element-544">
                <h3 className="text-lg font-serif font-bold mb-2 text-white drop-shadow-lg" data-id="element-545">
                  {resources[4].title}
                </h3>
                <p className="text-sm text-gray-100 drop-shadow-md" data-id="element-546">
                  {resources[4].desc}
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.35
        }} className="md:col-span-1 md:row-span-1 relative group overflow-hidden" data-id="element-547">
            <div className="relative w-full h-full" data-id="element-548">
              <img src={resources[5].image} alt={resources[5].title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-549" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#1e3a5f] via-[#1e3a5f]/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-550"></div>
              <div className="absolute inset-0 flex flex-col justify-end p-6 opacity-0 group-hover:opacity-100 transition-all duration-500 transform translate-y-4 group-hover:translate-y-0" data-id="element-551">
                <h3 className="text-lg font-serif font-bold mb-2 text-white drop-shadow-lg" data-id="element-552">
                  {resources[5].title}
                </h3>
                <p className="text-sm text-gray-100 drop-shadow-md" data-id="element-553">
                  {resources[5].desc}
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="md:col-span-2 md:row-span-2 relative group overflow-hidden" data-id="element-554">
            <div className="relative w-full h-full" data-id="element-555">
              <img src={promoImages[1].image} alt={promoImages[1].title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-556" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#1e3a5f]/80 via-[#1e3a5f]/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-557"></div>
              <div className="absolute inset-0 flex flex-col justify-end p-8 opacity-0 group-hover:opacity-100 transition-all duration-500 transform translate-y-4 group-hover:translate-y-0" data-id="element-558">
                <h3 className="text-2xl font-serif font-bold mb-2 text-white drop-shadow-lg" data-id="element-559">
                  {promoImages[1].title}
                </h3>
                <p className="text-base text-gray-100 drop-shadow-md" data-id="element-560">
                  {promoImages[1].desc}
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.45
        }} className="md:col-span-1 md:row-span-2 relative group overflow-hidden" data-id="element-561">
            <div className="relative w-full h-full" data-id="element-562">
              <img src={resources[6].image} alt={resources[6].title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-563" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#1e3a5f] via-[#1e3a5f]/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-564"></div>
              <div className="absolute inset-0 flex flex-col justify-end p-6 opacity-0 group-hover:opacity-100 transition-all duration-500 transform translate-y-4 group-hover:translate-y-0" data-id="element-565">
                <h3 className="text-lg font-serif font-bold mb-2 text-white drop-shadow-lg" data-id="element-566">
                  {resources[6].title}
                </h3>
                <p className="text-sm text-gray-100 drop-shadow-md" data-id="element-567">
                  {resources[6].desc}
                </p>
              </div>
            </div>
          </motion.div>
        </div>

        <div className="mt-16 bg-[#f4e4d7]/30 rounded-2xl p-8 md:p-12 text-center border border-[#d4a574]/20" data-id="element-568">
          <h3 className="text-2xl font-serif font-bold text-[#1e3a5f] mb-4" data-id="element-569">
            ¿Cómo funciona el reto de 30 días?
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-8" data-id="element-570">
            <div className="relative" data-id="element-571">
              <div className="w-10 h-10 bg-[#1e3a5f] text-white rounded-full flex items-center justify-center font-bold mx-auto mb-4 z-10 relative" data-id="element-572">
                1
              </div>
              <div className="hidden md:block absolute top-5 left-1/2 w-full h-0.5 bg-[#d4a574]/30 -z-0" data-id="element-573" />
              <h4 className="font-bold text-[#1e3a5f] mb-2" data-id="element-574">
                Lee la lección diaria
              </h4>
              <p className="text-sm text-gray-600" data-id="element-575">
                Lecturas cortas y motivadoras de 5 minutos.
              </p>
            </div>
            <div className="relative" data-id="element-576">
              <div className="w-10 h-10 bg-[#1e3a5f] text-white rounded-full flex items-center justify-center font-bold mx-auto mb-4 z-10 relative" data-id="element-577">
                2
              </div>
              <div className="hidden md:block absolute top-5 left-1/2 w-full h-0.5 bg-[#d4a574]/30 -z-0" data-id="element-578" />
              <h4 className="font-bold text-[#1e3a5f] mb-2" data-id="element-579">
                Haz el ejercicio práctico
              </h4>
              <p className="text-sm text-gray-600" data-id="element-580">
                Aplica lo aprendido inmediatamente en tu vida.
              </p>
            </div>
            <div className="relative" data-id="element-581">
              <div className="w-10 h-10 bg-[#1e3a5f] text-white rounded-full flex items-center justify-center font-bold mx-auto mb-4 z-10 relative" data-id="element-582">
                3
              </div>
              <h4 className="font-bold text-[#1e3a5f] mb-2" data-id="element-583">
                Celebra tu progreso
              </h4>
              <p className="text-sm text-gray-600" data-id="element-584">
                Siente la paz de tener el control día a día.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}